import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../component/Header";
import BottomNav from "../component/BottomNav";
import BookList from "../component/BookList";

import cookie from 'react-cookie';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-125086411-4');

class InfoView extends Component {

	constructor(props) {
		super(props);

		this.state = { headerTitle: "더책" };
		this.state = {
			...this.state,
			title: this.props.location.state.title,
			url: this.props.location.state.url
		};
		//console.log("inner url: "+this.props.location.state.url)	;
	}


    logPageView() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location + "&orgid=" + cookie.load("orgid"));
    }

    render() {
        this.logPageView();

        var iframe = `<iframe class="infoview" scrolling="yes" src="${this.state.url}" frameborder="no" allowtransparency="true" allowfullscreen="true"></iframe>`;
		
		return (
			<React.Fragment>
				<Header headerTitle={this.state.headerTitle} />
                <div className="section">
					<div className="section-body">
                        <div dangerouslySetInnerHTML={{ __html: iframe }} />
					</div>
				</div>

				<BottomNav />
			</React.Fragment>
        );

        //<div className="section-header">
        //<h2 className="section-title">
        //    <br />
        //    <br />
        //    {this.state.title}
        //</h2>
	    //</div >
	}
}

export default InfoView;
